import { heroStats, heroTags } from '@/mocks/home';

export default function Hero() {
  return (
    <section
      id="top"
      className="relative overflow-hidden bg-background-50 px-4 pb-16 pt-24 md:px-8 md:pb-24 md:pt-32"
    >
      <div className="pointer-events-none absolute -right-24 top-10 h-80 w-80 rounded-full bg-accent-100/60 blur-3xl"></div>
      <div className="pointer-events-none absolute -left-24 bottom-0 h-72 w-72 rounded-full bg-primary-100/50 blur-3xl"></div>

      <div className="relative mx-auto grid w-full max-w-6xl grid-cols-1 items-center gap-10 lg:grid-cols-[1.05fr_0.95fr] lg:gap-16">
        <div>
          <span className="inline-flex items-center gap-2 rounded-full border border-accent-300/60 bg-accent-50 px-3 py-1 text-xs font-medium text-accent-900">
            <i className="ri-film-line" aria-hidden="true"></i>
            剧集资料 · 观剧参考站
          </span>

          <h1 className="mt-5 font-heading text-3xl font-black leading-tight text-foreground-950 md:text-5xl md:leading-[1.15]">
            看懂《出轨同学会》
            <br />
            <span className="text-primary-600">一场重逢里的全部暗线</span>
          </h1>

          <p className="mt-5 max-w-xl text-sm leading-7 text-foreground-600 md:text-base md:leading-8">
            这一页把散落各处的零碎资料重新理顺：剧情脉络、六位核心角色的关系网、八集看点速览与主题解读，
            帮你在追剧前先搭好框架。这里只做内容参考，观看请前往正版平台。
          </p>

          <div className="mt-8 flex flex-col gap-3 sm:flex-row">
            <a
              href="#story"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
            >
              <i className="ri-book-open-line" aria-hidden="true"></i>
              从剧情看点开始
            </a>
            <a
              href="#watch"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-6 py-3 text-sm font-medium text-foreground-800 transition-colors hover:bg-background-100"
            >
              <i className="ri-play-circle-line" aria-hidden="true"></i>
              正版观看指南
            </a>
          </div>

          <ul className="mt-6 flex flex-wrap gap-2">
            {heroTags.map((tag) => (
              <li
                key={tag}
                className="rounded-full bg-secondary-100 px-3 py-1 text-xs font-medium text-secondary-900"
              >
                {tag}
              </li>
            ))}
          </ul>
        </div>

        <div className="relative">
          <div className="relative overflow-hidden rounded-lg border border-background-200 bg-background-100 p-2">
            <div className="h-[380px] w-full overflow-hidden rounded-md md:h-[520px]">
              <img
                src="https://readdy.ai/api/search-image?query=Cinematic%20film%20still%20of%20an%20elegant%20long%20dinner%20table%20set%20for%20an%20intimate%20evening%20class%20reunion%2C%20crystal%20wine%20glasses%20glinting%2C%20warm%20candlelight%2C%20softly%20blurred%20figures%20seated%20in%20the%20background%2C%20set%20inside%20a%20dim%20sophisticated%20private%20dining%20room%20with%20warm%20amber%20and%20deep%20wine%20tonal%20palette%2C%20shallow%20depth%20of%20field%2C%20subtle%20film%20grain%2C%20moody%20atmospheric%20editorial%20photography&width=1000&height=1250&seq=ds-hero-01&orientation=portrait"
                alt="暖色调的私人餐厅场景，长桌上摆着酒杯与烛光，暗示一场同学会晚宴"
                className="h-full w-full object-cover object-top"
              />
            </div>
          </div>

          <div className="absolute -bottom-5 left-4 right-4 rounded-lg border border-background-200 bg-background-50/95 p-4 backdrop-blur md:left-auto md:right-6 md:w-64">
            <p className="font-heading text-sm font-semibold text-foreground-950">
              一句话看懂
            </p>
            <p className="mt-1 text-xs leading-6 text-foreground-600">
              同学会散场之前，每个人都要面对自己藏了十几年的那个选择。
            </p>
          </div>
        </div>
      </div>

      <div className="relative mx-auto mt-16 grid w-full max-w-6xl grid-cols-2 gap-4 md:mt-24 md:grid-cols-4 md:gap-6">
        {heroStats.map((stat) => (
          <div
            key={stat.label}
            className="rounded-lg border border-background-200 bg-background-100 p-4 md:p-5"
          >
            <p className="font-heading text-2xl font-bold text-primary-600 md:text-3xl">
              {stat.value}
            </p>
            <p className="mt-1 text-xs text-foreground-600 md:text-sm">{stat.label}</p>
          </div>
        ))}
      </div>
    </section>
  );
}